import { FieldDef, FieldType, FormFieldType, FormResult, FormsResultsDTO, UploadFormFileDTO } from '../types/forms';

export const unifyFormTypes = (fieldType: FieldType, isFormulaField: boolean, formula: string, potionsCount: number, typeBehavior: string): FormFieldType => {
    if (isFormulaField && formula && formula.length > 0) {
        return 'formula';
    }

    switch (fieldType) {
        case 'string':
        case 'number':
        case 'date':
        case 'color':
        case 'url':
        case 'image':
        case 'video':
        case 'document':
        case 'widget':
            return fieldType;
        case 'text':
        case 'json':
            return 'text';
        case 'hidden':
            return 'password';
        case 'bool':
            return 'radio';
        case 'enumerated':
        case 'orderedset':
            if (potionsCount < 4 && typeBehavior !== 'multiple') {
                return 'radio';
            }
            return 'select';
        case 'zipcode':
            return 'number';
        case 'geoloc':
            return 'text';
    }
};

export const transformFormFields = (
    data: any[],
    values: {
        [key: string]: string | number | null
    } = {},
) => {
    return data.map(item => {
        return {
            id: item.id || item.fieldID || item.name,
            fieldID: item.fieldID,
            label: item.title,
            name: item.name || item.id,
            group: item.group,
            type: unifyFormTypes(item.type, item.calculated, item.formula, item.options?.length || 0, item.typebehavior || ''),
            typeBehavior: item.typebehavior,
            src: item.src,
            hidden: item.hidden || false,
            required: item.required || false,
            options: item.options,
            defaultValue: values[item.id] || item.defaultValue || undefined,
            formula: item.formula ? item.formula : '',
            calculated: item.calculated || false,
            source: item.source,
            constraints: item.constraint,
            infoLink: item.infoLink || '',
        };
    });
};

export const transformFormResponses = (responses: FormsResultsDTO['responses']): FormResult[] => {
    return responses.map(response => {
        const responseData: Record<string, any> = {};
        response.response.forEach(item => {
            responseData[item.id] = item.value;
        });

        return {
            id: response.response_id,
            date: response.date,
            userEmail: response.user?.email || '-',
            ...responseData,
        };
    });
};

export const resolveUploads = async (
    formId: string | number,
    fields: FieldDef[],
    values: Record<string, any>,
    upload: (formId: string | number, file: File) => Promise<UploadFormFileDTO>,
) => {
    const out: Record<string, any> = { ...values };

    const uploadDefs = fields.filter((f) => f.type === 'image' || f.type === 'video' || f.type === 'document');

    await Promise.all(
        uploadDefs.map(async (field) => {
            const value = out[field.id];
            const file = value instanceof File ? value : null;

            if (!file) {
                out[field.id] = value ?? '';
                return;
            }

            const response = await upload(formId, file);
            out[field.id] = response.url;
        }),
    );

    return out;
};